import axiosInstance from './axiosInstance';

const dataService = {
  getActionTypes: async () => {
    try {
      const response = await axiosInstance.post('/actions/action-types', {pay:"load"});
      return response.data.action_types;
    } catch (error) {
      console.error('Error creating document', error.response?.data || error.message);
      throw error;
    }
  },
  sendEmail: async (email) => {
    try {
      const response = await axiosInstance.post('/actions/email', email);
      return response.data;
    } catch (error) {
      console.error('Error sending email', error.response?.data || error.message);
      throw error;
    }
  },
  createDocument: async () => {
    try {
      const response = await axiosInstance.post('/actions/create-document', {pay:"load"});
      return response.data;
    } catch (error) {
      console.error('Error creating document', error.response?.data || error.message);
      throw error;
    }
  },
  performAction: async (payload) => {
    try {
      const response = await axiosInstance.post('/actions/perform-action', payload);
      return response.data;
    } catch (error) {
      console.error('Error creating document', error.response?.data || error.message);
      throw error;
    }
  },
  sendMessage: async (payload) => {
    try {
      const response = await axiosInstance.post('/actions/send-message', payload);
      return response.data;
    } catch (error) {
      console.error('Error creating document', error.response?.data || error.message);
      throw error;
    }
  },
  prelimQuestions: async (payload) => {
    try {
      const response = await axiosInstance.post('/actions/prelim-questions', payload);
      return response.data;
    } catch (error) {
      console.error('Error creating document', error.response?.data || error.message);
      throw error;
    }
  },
};

export default dataService;
